import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components/misc'

export const StyledEmbeddedCommunity = styled.div`
  &[data-fetching='true'] {
    display: none;
  }
  margin-block: 16px;
  padding: 24px 16px;
  border-radius: 8px;
  background-color: ${theme?.colors.neutral50};
  content-visibility: auto;
  contain-intrinsic-size: 800px;
  ${MediaQueries.mbDown} {
    margin-inline: -16px;
  }
`

export const StyledCommunitySection = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;
  ${MediaQueries.mbDown} {
    flex-direction: column;
    gap: 8px;
  }
  .grow {
    flex-grow: 1;
  }
  .ask {
    white-space: nowrap;
  }
  .thumbnail {
    ${MediaQueries.mbDown} {
      width: 40px;
      height: 40px;
    }
    ${MediaQueries.mbUp} {
      width: 48px;
      height: 48px;
    }
    border-radius: 50%;
    &-header {
      flex-shrink: 0;
      ${MediaQueries.mbDown} {
        display: flex;
        /* justify-content: space-between; */
        gap: 16px;

        /* > div {
          display: flex;
          gap: 16px;
        } */
      }
    }
  }
  .detail {
    &-general {
      ${MediaQueries.mbUp} {
        min-height: 50px;
      }
    }
    width: 100%;
    flex-grow: 1;
    gap: 4px;
    display: flex;
    flex-direction: column;
    &-statistic {
      display: flex;
      gap: 16px;
    }
    &-tag {
      display: flex;
      gap: 8px;
      align-items: center;
      justify-content: space-between;

      ${MediaQueries.mbDown} {
        flex-direction: column;
      }
      .ask {
        margin-left: auto;
      }
    }
  }
`

export const StyledPostSection = styled.div`
  background-color: #ffffff;
  margin-top: 16px;
  padding: 16px 24px;
  ${MediaQueries.mbDown} {
    padding: 16px;
  }
  border: 1px solid ${theme?.colors.neutral100};
  border-radius: 8px;
  hr {
    margin-top: 24px;
    margin-bottom: 16px;
    border: 1px solid ${theme?.colors.neutral100};
  }
  .join {
    margin-top: 16px;
  }
`
